import { DataTables } from 'components/organisms/DataTable/index'
import React from 'react'

const LogDetail = ({ row = {}, isMobileView = false }) => {

  const config = [
    {
      dataField: 'oldValue',
      text: 'Old Value',
      headerAttrs: { width: isMobileView ? 150 : 200 },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return <pre>{JSON.stringify(JSON.parse(row.oldValue), undefined, 2)}</pre>
      },
      align: 'left',
      classes: 'bg-white border',
      sort: true
    },
    {
      dataField: 'newValue',
      text: 'New Value',
      headerAttrs: { width: isMobileView ? 150 : 200 },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return <pre>{JSON.stringify(JSON.parse(row.newValue), undefined, 2)}</pre>
      },
      align: 'left',
      classes: 'bg-white border',
      sort: true
    },
  ]

  return (
    <div>
      <DataTables
        key={row.id}
        containerClassName="col-12 px-0"
        minWidth={'700px'}
        noHeadings
        rightSlotAlt={true}
        defaultSize={100}
        dataList={[row] || []}
        columnConfig={config}
      />
    </div>
  )
}

export default LogDetail
